import { useMutation, useQueryClient } from "react-query";
import { api } from "utils/api";
import { postKeys } from "./queryKeys";
import { FeedResponse, Post } from "../types";

type PostReaction = {
  postId: string;
  reaction: string;
  cancelReaction?: boolean;
};

type PostReactionResponse = {
  postId: string;
  reacted: boolean;
  updatedPost: Post;
};

const updatePostReaction = async (reaction: PostReaction) =>
  api.post<PostReactionResponse>("/reaction/post", {
    body: JSON.stringify(reaction),
    requireAuth: true,
  });

const usePostReact = (postId?: string) => {
  const queryClient = useQueryClient();
  const { mutate, ...mutation } = useMutation(
    (fields: PostReaction) => updatePostReaction(fields),
    {
      onSuccess: (data) => {
        // Reset for Permalink Page
        queryClient.setQueryData(postKeys.detail(postId), data.updatedPost);

        // Reset for Feeds

        // Get All Feed Infinite Queries
        const feeds = queryClient.getQueriesData<{ pages: FeedResponse[] }>(
          postKeys.lists()
        );

        // Search Page Data for This Post & Replace
        feeds.forEach((feed) => {
          const { pages } = feed[1];
          pages.forEach((page) => {
            const { data: posts } = page;
            const index = posts.findIndex((post) => post.id === postId);
            if (index >= 0) {
              posts[index] = data.updatedPost;
            }
          });
          queryClient.setQueryData(feed[0], feed[1]);
        });
      },
    }
  );

  const cheer = () =>
    postId ? mutate({ postId, reaction: "CHEER" }) : undefined;
  const unCheer = () =>
    postId
      ? mutate({ postId, reaction: "CHEER", cancelReaction: true })
      : undefined;

  return { cheer, unCheer, ...mutation };
};

export { usePostReact };
